import {styled} from '@mui/material';
import React, {FC, useMemo, useState, useCallback, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import {Table} from 'thermia-react-container';
import {Column} from "react-table";
import {PartnerInfo} from "../../../../types/registrationTypes";

const StyledContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  height: '36px',
  nowrap: 'nowrap'
}));

type Props = {
  data: PartnerInfo[];
  action: (partner: PartnerInfo) => void;
  
};

const AdminPartnersTable: FC<Props> = ({data, action}) => {
  const { t } = useTranslation('registrations');
  const [tableMethods] = useState({
    refreshData: () => Promise.resolve() // function will be set by the table
  });

  useEffect(() => {
    tableMethods.refreshData();
  }, [data, tableMethods]);

  const columns = useMemo((): Column<PartnerInfo>[] => {
    return [
      {
        accessor: 'customerId',
        Header: t('registrations.admin.customerNumber') ?? 'Customer ID',
        Cell: (prop: any) => (
          <StyledContainer>
            <span>{prop.row.original.customerId}</span>
          </StyledContainer>
        )
      },
      {
        accessor: 'companyName',
        Header: t('registrations.general.customer') ?? 'Company',
        Cell: (prop: any) => (
          <StyledContainer>
            <span>{prop.row.original.companyName}</span>
          </StyledContainer>
        )
      },
    ]}, [t]);


  const fetchDataFunction = useCallback(async (_pagination: any) => {
    return {
      data: data,
      totalCount: data.length
    };
  }, [data]);
  
  return (
    <Table 
      columns={columns} 
      fetchData={fetchDataFunction} 
      exposedMethods={tableMethods} 
      onClick={action} 
      pagination={true} 
      sortable={true}
    />
  );
};

export default AdminPartnersTable;
